export interface IChessGameRules {
  moveTime: number
  layoutDelay: number
  handicapDelay: number
}

let _obj: IChessGameRules | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setNormal()
  }
  return _obj
}

function create() {
  let obj: IChessGameRules = {
    moveTime: 0, // 5
    layoutDelay: 0, // 0.025
    handicapDelay: 0, //  0.5
  }
  return obj
}

export function setSuperTest() {
  let obj = get()
  obj.moveTime = 0
  obj.layoutDelay = 0
  obj.handicapDelay = 0
}
export function setNormal() {
  let obj = get()
  obj.moveTime = 5
  obj.layoutDelay = 0.025
  obj.handicapDelay = 0.5
}

export function setMoveTime(v: number) {
  let obj = get()
  obj.moveTime = v
}
